import FullProduct from './FullProduct';

export default function ChildFullProduct() {
  return FullProduct.named('ChildFullProduct');
}
